module.exports = __webpack_public_path__ + "img/successfull.58212d0f.png";